import Modal from "../modal";

export default Modal.extend({
  className: [Modal.prototype.className, "save-failure"].join(" "),

  template: require("./save-failure.hbs"),
  style: require("./save-failure.styl"),

  open(renderData) {
    this.renderData = renderData;
    Modal.prototype.open.call(this);
  },

  render() {
    this.$el.html(this.template(this.renderData));

    this.delegateEvents();
  },
});
